//@flow
import * as React from 'react';
import { withRouter } from 'common/components/core/router';
import { createEntityImportContainer } from 'common/entity/generic/EntityImportContainer';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import LineItemActions from 'common/redux/actions/lineItem';
import { EntityImportHelper } from 'common/entity/helpers/EntityImportHelper';
import { translate } from 'react-i18next';
import { memoizedImmutable } from 'common/utils/Memoizer';
import { withUnitConverter } from 'common/containers/intl';
import { ENTITY_NAME_ID } from 'common/constants/entity/lineItemMaster';
import LINE_ITEM_IMPORT_FORMAT from './tableConfig';
import LineItemImportHelper from './LineItemImportHelper';
import LineItemMasterImportWorker from './workers/LineItemMasterImportWorker';

const actions = {
    addEntities: LineItemActions.addEntities
};

const EntityImportContainer = createEntityImportContainer({
    ImportWorker: LineItemMasterImportWorker
});

class LineItemMasterImportContainer extends React.PureComponent {
    @memoizedImmutable()
    getDefaultColumns(entitySettings, t) {
        const customFields = LineItemImportHelper.getCustomFields(
            entitySettings
        );

        return EntityImportHelper.getDefaultColumns({
            columns: LINE_ITEM_IMPORT_FORMAT,
            customFields,
            t,
            entityNameId: ENTITY_NAME_ID
        });
    }

    @memoizedImmutable()
    getTemplateRow(entitySettings, t) {
        const customFields = LineItemImportHelper.getCustomFields(
            entitySettings
        );

        return EntityImportHelper.getTemplateRow({
            columns: LINE_ITEM_IMPORT_FORMAT,
            customFields,
            t,
            entityNameId: ENTITY_NAME_ID,
            translationKeys: {}
        });
    }

    render() {
        const { entitySettings, t } = this.props;
        return (
            <EntityImportContainer
                {...this.props}
                generateEntityList={LineItemImportHelper.generateEntityList}
                entityNameId={ENTITY_NAME_ID}
                templateRowData={this.getTemplateRow(entitySettings, t)}
                defaultColumns={this.getDefaultColumns(entitySettings, t)}
            />
        );
    }
}
export default compose(
    withRouter,
    withUnitConverter,
    connect(null, actions),
    translate('entityManagement')
)(LineItemMasterImportContainer);
